import {useParams} from "react-router-dom";
import { useNavigateWithCommune } from '../services/Utils';

export default function Tempo(){
    let { pageSuivante } = useParams();
    
    const navigate = useNavigateWithCommune();

    setTimeout(()=>{
        navigate(decodeURIComponent(pageSuivante))
    },1000)

}